import React from 'react'
import { connect } from 'react-redux'
import uuid from 'uuid/v4'
import styled from 'styled-components'
import {
  getRelationCases,
  getRelationFinishedStatus,
  hasConfirmedRelationProffSelection,
  isAdmin,
  isCaseRelevant,
  isRelationCasesPending,
} from '../../redux/selectors'
import { addConnection, unsetActiveConnection } from '../../redux/actions'
import ListItem from './ListItem'
import {
  RELATION
} from '../../connectionTypes'
import relationIcon from '../../icons/relation.svg'
import I18n, { useI18nFunction } from '../I18n'

const RelationListItem = ({
  id: relationId,
  item,
  firstName,
  lastName,
  relationType,
  addConnection,
  activeConnection,
  active,
  connectionType,
  editable,
  connection,
  relationCases,
  isCurrentUsersProfile,
  disabledInteraction,
  hasConfirmedProffSelection,
  currentItems,
  previousItems,
  notRelevantItems,
  isCasesPending,
  userId,
  isAdmin,
  relationFinishedStatus
}) => {
  const I18nFunction = useI18nFunction()
  return (
    <li>
      <ListItem
        connectionType={RELATION}
        relation={item}
        id={relationId}
        active={active}
        checked={relationFinishedStatus}
        connection={connection}
        editable={editable}
        image={relationIcon}
        isCurrentUsersProfile={isCurrentUsersProfile||isAdmin}
        title={
          firstName && lastName
            ? `${firstName} ${lastName}`
            : firstName
            ? firstName
            : lastName
            ? lastName
            : undefined
        }
        titleFallback={
          <I18n id="connection_list_item.relation_title_fallback" />
        }
        description={I18nFunction({
          id: `connection_form.relation_types.${relationType}`,
        })}
        descriptionFallback={
          <I18n id="connection_list_item.relation_description_fallback" />
        }
      />
      <Children>
        
        
      </Children>
    </li>
  )
}


const Children = styled.div`
  margin-left: 3em;
`

const mapStateToProps = (state, props) => {
  const connectionKeys = {
    relationPublicDataOwnership: 'relationPublicDataOwnership',
    relationOwnership: 'relationOwnership',
    relationPublicDataRole: 'relationPublicDataRole',
    relationRole: 'relationRole',
    relationOtherConnection: 'relationOtherConnection',
  }
  const relationCases = getRelationCases(state, props.id)
  const hasConfirmedProffSelection = hasConfirmedRelationProffSelection(
    state,
    props.id,
  )
  const items = relationCases
  let previousItems = []
  let currentItems = []
  let notRelevantItems = []
  items
    .sort(sortByUpdatedOn)
    .sort((a, b) => sortByWhetherUserConfirmed(a, b, connectionKeys))
   
  let nonApplicationItems = items?.filter(
    (c) =>
      c[connectionKeys.relationPublicDataOwnership] ||
      c[connectionKeys.relationOwnership] ||
      c[connectionKeys.relationPublicDataRole] ||
      c[connectionKeys.relationRole] ||
      c[connectionKeys.relationOtherConnection],
  )
   
  notRelevantItems = nonApplicationItems.filter(
    (c) => !isCaseRelevant(c) )

  const relevantItems = nonApplicationItems.filter(
    (c) => !notRelevantItems.includes(c))

  previousItems = relevantItems
    .filter((c) =>
      hasEnded(
        c[connectionKeys.relationOwnership] ||
          c[connectionKeys.relationRole] ||
          c[connectionKeys.relationOtherConnection],
      ),
    )
    .filter((item) => !item.caseType?.toLowerCase().includes('indirect'))
  currentItems = relevantItems
    .filter(
      (c) =>
        !hasEnded(
          c[connectionKeys.relationOwnership] ||
            c[connectionKeys.relationRole] ||
            c[connectionKeys.relationOtherConnection],
        ),
    )
    .filter((item) => !item.caseType?.toLowerCase().includes('indirect'))
  return {
    previousItems: previousItems,
    currentItems: currentItems,
    notRelevantItems: notRelevantItems,
    relationCases,
    hasConfirmedProffSelection,
    isCasesPending: isRelationCasesPending(state, props.userId),
    relationFinishedStatus: getRelationFinishedStatus(state,props.userId, props.id),
    isAdmin: isAdmin(state)

  }
}

const mapDispatchToProps = (dispatch, { id: relationId }) => ({
  addConnection: (connectionType, ownershipType) =>
    dispatch(
      addConnection({
        id: uuid(),
        relationId,
        connectionType,
        ownershipType
      }),
    ),
  unsetActiveConnection: () => dispatch(unsetActiveConnection),
})

export default connect(mapStateToProps, mapDispatchToProps)(RelationListItem)

const hasEnded = (userRegisteredConnection) =>
  Date.parse(userRegisteredConnection?.toDate) < Date.now()

const sortByUpdatedOn = (a, b) => {
  if (a.updatedOn > b.updatedOn) return -1
  if (a.updatedOn < b.updatedOn) return 1
  return 0
}

const sortByWhetherUserConfirmed = (a, b, connectionKeys) => {
  if (!a[connectionKeys.userRegistered] && b[connectionKeys.userRegistered])
    return -1
  if (a[connectionKeys.userRegistered] && !b[connectionKeys.userRegistered])
    return 1
  return 0
}
